import { intl, mathService, numberHelpers, typeGuardHelpers } from '@approvalmax/utils';

import { isFieldVisible } from '../../NetSuiteRequestCard.helpers';
import { messages } from './NetSuiteItemReceiptExpenses.messages';
import {
    ItemReceiptExpensesColumnDefinition,
    NetSuiteItemReceiptExpensesConfigParams,
} from './NetSuiteItemReceiptExpenses.types';

export const getColumnDefinitions = ({
    fieldSettings,
    customFieldsColumnDefinitions,
    exchangeRate,
}: NetSuiteItemReceiptExpensesConfigParams) => {
    const columnDef: ItemReceiptExpensesColumnDefinition[] = [
        {
            id: 'account',
            name: messages.accountColumnName,
            value: (li) => li.account?.text ?? null,
        },
        {
            id: 'memo',
            name: messages.memoColumnName,
            value: (li) => li.memo,
            minWidth: 150,
        },
        {
            id: 'amount',
            name: messages.amountColumnName,
            value: (li) => {
                let amount = li.amount ?? 0;

                if (numberHelpers.isNumber(exchangeRate)) {
                    amount = mathService.multiply(amount, exchangeRate);
                    amount = mathService.round(amount, 2);
                }

                return intl.formatNumber(amount, 'auto');
            },
            alignRight: true,
        },
        ...customFieldsColumnDefinitions,
    ];

    return columnDef.filter((col) => {
        const setting = typeGuardHelpers.isKeyOfObject(col.id, fieldSettings) ? fieldSettings[col.id] : undefined;

        return isFieldVisible(setting);
    });
};
